export default __webpack_public_path__ + "static/media/apa.a6a985e0.png";